import { useState, useEffect } from "react";

/* Tiny toast helper — single global toast queue, fades out after ~1.6s.
   Identical behavior to the old admin: call toast("message") from anywhere
   and the message renders at the bottom-center of the screen.
   Centralized so phone/WA copy actions and other UI bits don't each
   reimplement a notification. */
let _toastSetter = null;

export function Toast() {
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    _toastSetter = (text) => {
      setMsg(text);
      setTimeout(() => setMsg(null), 1600);
    };
    return () => { _toastSetter = null; };
  }, []);
  if (!msg) return null;
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[200] bg-slate-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg pointer-events-none">
      {msg}
    </div>
  );
}

export function toast(text) {
  _toastSetter?.(text);
}
